module.exports = __webpack_public_path__ + "static/media/9.b9e5254a.jpg";